const SPEED_ANALYSER_ERROR_BASE = 0x3000;

export const SpeedAnalyserErrorCodes = Object.freeze({
  /**
   * Indicates that the speed test detection failed.
   * Base error code: 0x3001
   */
  SPEED_TEST_DETECTION_FAILURE: SPEED_ANALYSER_ERROR_BASE + 0x01,
});
